
import { connect } from 'react-redux';
import ArtistsSlider from '../components/ArtistsSliderComponent';
import { fetchArtistsSlidesIfNeeded } from '../actions/ArtistsActions';

const mapStateToProps = (state) => {
    const isMobile = state.clientInfo.isMobile;

    return {
        dataArtistsSlider: state.artists.ArtistsAll.dataArtistsSlider,
        device: isMobile || 'desktop',
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchArtistsSlidesIfNeeded: () => {
        dispatch(fetchArtistsSlidesIfNeeded());
    },
});

const ArtistsSliderContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ArtistsSlider);

export default ArtistsSliderContainer;
